import { hideLoading, showLoading } from 'react-redux-loading-bar';
import api from '../../utils/api/api';

import {
  SET_CREATE_COMMENT,
  SET_DOWN_VOTE_COMMENT,
  SET_NEUTRAL_VOTE_COMMENT,
  SET_UP_VOTE_COMMENT,
} from '../../utils/common/constant';

const ActionTypeComment = {
  SET_CREATE_COMMENT,
  SET_DOWN_VOTE_COMMENT,
  SET_NEUTRAL_VOTE_COMMENT,
  SET_UP_VOTE_COMMENT,
};

const createCommentThreadActionCreator = (comment) => {
  return {
    type: ActionTypeComment.SET_CREATE_COMMENT,
    payload: {
      comment,
    },
  };
};

const downVoteCommentActionCreator = (userId, commentId) => {
  return {
    type: ActionTypeComment.SET_DOWN_VOTE_COMMENT,
    payload: {
      userId,
      commentId,
    },
  };
};

const neutralVoteCommentActionCreator = (userId, commentId) => {
  return {
    type: ActionTypeComment.SET_NEUTRAL_VOTE_COMMENT,
    payload: {
      userId,
      commentId,
    },
  };
};

const upVoteCommentActionCreator = (userId, commentId) => {
  return {
    type: ActionTypeComment.SET_UP_VOTE_COMMENT,
    payload: {
      userId,
      commentId,
    },
  };
};

const asyncCreateComment = ({ threadId, content }) => {
  return async (dispatch) => {
    dispatch(showLoading());

    try {
      const comment = await api.createComment({ threadId, content });
      dispatch(createCommentThreadActionCreator(comment));
    } catch (error) {
      dispatch(hideLoading());
      alert(error.message);
    }

    dispatch(hideLoading());
  };
};

const asyncDownVoteComment = (commentId) => {
  return async (dispatch, getState) => {
    const { authUser, threadDetail } = getState();

    dispatch(showLoading());
    dispatch(downVoteCommentActionCreator(authUser.id, commentId));

    try {
      await api.downVoteThreadComment(threadDetail.id, commentId);
    } catch (error) {
      dispatch(hideLoading());
      alert(error.message);
    }

    dispatch(hideLoading());
  };
};

const asyncNeutralVoteComment = (commentId) => {
  return async (dispatch, getState) => {
    const { authUser, threadDetail } = getState();

    dispatch(showLoading());
    dispatch(neutralVoteCommentActionCreator(authUser.id, commentId));

    try {
      await api.neutralVoteThreadComment(threadDetail.id, commentId);
    } catch (error) {
      dispatch(hideLoading());
      alert(error.message);
    }

    dispatch(hideLoading());
  };
};

const asyncUpVoteComment = (commentId) => {
  return async (dispatch, getState) => {
    const { authUser, threadDetail } = getState();

    dispatch(showLoading());
    dispatch(upVoteCommentActionCreator(authUser.id, commentId));

    try {
      await api.upVoteThreadComment(threadDetail.id, commentId);
    } catch (error) {
      dispatch(hideLoading());
      alert(error.message);
    }

    dispatch(hideLoading());
  };
};

export {
  ActionTypeComment,
  createCommentThreadActionCreator,
  downVoteCommentActionCreator,
  neutralVoteCommentActionCreator,
  upVoteCommentActionCreator,
  asyncCreateComment,
  asyncDownVoteComment,
  asyncNeutralVoteComment,
  asyncUpVoteComment,
};
